import type { OrganizationProfile } from '../../store/organizationStore';

/**
 * The data domains (`data_domains.slug`) a member is limited to, for the navigation only
 * (PLAN-GENERICITE § 3.1: « masquer dans la navigation ce qui est hors périmètre », comfort, not
 * security). Empty means no restriction: the owner is never restricted, nor a member whose scope is
 * empty, nor a viewer the record does not list (or no record yet). Pure.
 */
export function memberScope(
  organization: Pick<OrganizationProfile, 'members'> | null,
  userId: string | null | undefined,
): readonly string[] {
  const member = userId ? organization?.members.find((m) => m.user_id === userId) : undefined;
  return member === undefined || member.role === 'owner' ? [] : member.scope;
}
